'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bootstrap2Toggle = undefined;

var _reactBootstrapToggle = require('./react-bootstrap-toggle');

var _reactBootstrapToggle2 = _interopRequireDefault(_reactBootstrapToggle);

var _reactBootstrap2Toggle = require('./react-bootstrap2-toggle');

var _reactBootstrap2Toggle2 = _interopRequireDefault(_reactBootstrap2Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reactBootstrapToggle2.default;
exports.Bootstrap2Toggle = _reactBootstrap2Toggle2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-toggle/dist/index.js
// module id = 865
// module chunks = 0